import Plan from 'buy/Plan';
import { Middleware } from 'redux';
import RootState from '../RootState';

export const updateWindowPlan: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);
    const { user } = (store.getState() as RootState).app;
    (window as any).beatflyerPlan = user?.plan || Plan.Free;
  };



// WEBPACK FOOTER //
// ./src/state/side-effects/updateWindowPlan.ts